import React from 'react'
import { Typography } from '@mui/material'
import TileShell, { tileValueSx } from './TileShell'
import { statusColor } from './tileColors'

const formatValue = (value, format) => {
  if (value === null || value === undefined) return '—'
  switch (format) {
    case 'minutes':
      return `${value}m`
    case 'currency':
      return `£${Number(value).toLocaleString()}`
    case 'percent':
      return `${value}%`
    default:
      return Number(value).toLocaleString()
  }
}

const NumberTile = ({ kpi }) => {
  const status =
    kpi.tone === 'bad' && kpi.value > 0
      ? 'error'
      : kpi.tone === 'bad'
        ? 'success'
        : kpi.tone === 'good' && kpi.value > 0
          ? 'success'
          : 'neutral'
  // Neutral counts carry no status, so they stay in the default text colour
  const color = status === 'neutral' ? 'text.primary' : statusColor(status).main

  return (
    <TileShell
      dotColor={status === 'neutral' ? undefined : color}
      label={kpi.label}
      description={kpi.description}
      link={kpi.link}
    >
      <Typography sx={{ ...tileValueSx, color }}>{formatValue(kpi.value, kpi.format)}</Typography>
    </TileShell>
  )
}

export default NumberTile
